import { render } from "./Auth.vue?vue&type=template&id=5c87e2f0&scoped=true"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"

import "./Auth.vue?vue&type=style&index=0&id=5c87e2f0&scoped=true&lang=css"

import exportComponent from "/usr/local/share/application/bug-finder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c87e2f0"]])

export default __exports__